module.exports = __webpack_public_path__ + "static/media/waitApprove.8c4bc9dc.svg";